<template>
  <main class="page information">
    <div class="steps">
      <div v-for="(item, index) in steps" :key="item.label" :class="{ active: step === index, done: step > index }">
        <img :src="stepImage(item, index)" alt="" />
        <span>{{ item.label }}</span>
      </div>
    </div>

    <section class="form-section" :class="{ 'contact-form': step === 1 }">
      <template v-if="step === 0">
        <button type="button" class="personal-row" @click="openRegionPicker('residenceRegion')">
          <span>现居住省市区</span>
          <strong>{{ personal.residenceRegion }}</strong>
          <van-icon name="arrow" />
        </button>
        <div class="field-wrapper">
          <div class="personal-row detail-row">
            <label for="residence-address">详细地址</label>
            <input
              id="residence-address"
              v-model="personal.residenceAddress"
              type="text"
              placeholder="请输入详细居住地址"
              @blur="touchField('personal', 'residenceAddress')"
            />
            <button
              v-if="personal.residenceAddress"
              type="button"
              class="clear-input"
              aria-label="清空详细居住地址"
              @click="clearField('personal', 'residenceAddress')"
            >
              &times;
            </button>
          </div>
          <p v-if="touched.personal.residenceAddress && fieldErrors.personal.residenceAddress" class="field-error" role="alert">
            {{ fieldErrors.personal.residenceAddress }}
          </p>
        </div>
        <div class="field-wrapper">
          <div class="personal-row">
            <label for="company">单位名称</label>
            <input
              id="company"
              v-model="personal.company"
              type="text"
              placeholder="请输入单位名称"
              @blur="touchField('personal', 'company')"
            />
            <button
              v-if="personal.company"
              type="button"
              class="clear-input"
              aria-label="清空单位名称"
              @click="clearField('personal', 'company')"
            >
              &times;
            </button>
          </div>
          <p v-if="touched.personal.company && fieldErrors.personal.company" class="field-error" role="alert">
            {{ fieldErrors.personal.company }}
          </p>
        </div>
        <button type="button" class="personal-row" @click="openRegionPicker('companyRegion')">
          <span>单位省市区</span>
          <strong>{{ personal.companyRegion }}</strong>
          <van-icon name="arrow" />
        </button>
        <div class="field-wrapper">
          <div class="personal-row detail-row">
            <label for="company-address">详细地址</label>
            <input
              id="company-address"
              v-model="personal.companyAddress"
              type="text"
              placeholder="请输入单位详细地址"
              @blur="touchField('personal', 'companyAddress')"
            />
            <button
              v-if="personal.companyAddress"
              type="button"
              class="clear-input"
              aria-label="清空单位详细地址"
              @click="clearField('personal', 'companyAddress')"
            >
              &times;
            </button>
          </div>
          <p v-if="touched.personal.companyAddress && fieldErrors.personal.companyAddress" class="field-error" role="alert">
            {{ fieldErrors.personal.companyAddress }}
          </p>
        </div>
        <button type="button" class="personal-row" @click="marriagePicker.show = true">
          <span>婚姻状态</span>
          <strong>{{ personal.marriage }}</strong>
          <van-icon name="arrow" />
        </button>
        <button type="button" class="personal-row" @click="educationPicker.show = true">
          <span>最高学历</span>
          <strong>{{ personal.education }}</strong>
          <van-icon name="arrow" />
        </button>
        <div class="field-wrapper">
          <div class="personal-row income-row">
            <label for="income">年收入</label>
            <input
              id="income"
              v-model="personal.income"
              type="number"
              inputmode="decimal"
              placeholder="请输入年收入"
              @blur="touchField('personal', 'income')"
            />
            <button
              v-if="personal.income"
              type="button"
              class="clear-input"
              aria-label="清空年收入"
              @click="clearField('personal', 'income')"
            >
              &times;
            </button>
            <em>万元</em>
          </div>
          <p v-if="touched.personal.income && fieldErrors.personal.income" class="field-error" role="alert">
            {{ fieldErrors.personal.income }}
          </p>
        </div>
      </template>

      <template v-else-if="step === 1">
        <div class="contact-step">
          <h2 class="contact-group-title">联系人</h2>
          <section class="contact-card">
            <button type="button" class="contact-row" @click="openOptionPicker('firstRelation')">
              <span>关系</span>
              <strong>{{ contact.firstRelation }}</strong>
              <van-icon name="arrow" />
            </button>
            <div class="field-wrapper">
              <div class="contact-row">
                <label for="first-name">姓名</label>
                <input
                  id="first-name"
                  v-model="contact.firstName"
                  type="text"
                  placeholder="请输入真实的联系人姓名"
                  @blur="touchField('contact', 'firstName')"
                />
                <button
                  v-if="contact.firstName"
                  type="button"
                  class="clear-input"
                  aria-label="清空第一联系人姓名"
                  @click="clearField('contact', 'firstName')"
                >
                  &times;
                </button>
              </div>
              <p v-if="touched.contact.firstName && fieldErrors.contact.firstName" class="field-error" role="alert">
                {{ fieldErrors.contact.firstName }}
              </p>
            </div>
            <div class="field-wrapper">
              <div class="contact-row">
                <label for="first-tel">手机号</label>
                <input
                  id="first-tel"
                  v-model="contact.firstTel"
                  type="tel"
                  maxlength="11"
                  placeholder="请输入真实有效的联系人手机号"
                  @blur="touchField('contact', 'firstTel')"
                />
                <button
                  v-if="contact.firstTel"
                  type="button"
                  class="clear-input"
                  aria-label="清空第一联系人手机号"
                  @click="clearField('contact', 'firstTel')"
                >
                  &times;
                </button>
              </div>
              <p v-if="touched.contact.firstTel && fieldErrors.contact.firstTel" class="field-error" role="alert">
                {{ fieldErrors.contact.firstTel }}
              </p>
            </div>
          </section>

          <h2 class="contact-group-title">其他联系人</h2>
          <section class="contact-card">
            <button type="button" class="contact-row" @click="openOptionPicker('secondRelation')">
              <span>关系</span>
              <strong>{{ contact.secondRelation }}</strong>
              <van-icon name="arrow" />
            </button>
            <div class="field-wrapper">
              <div class="contact-row">
                <label for="second-name">姓名</label>
                <input
                  id="second-name"
                  v-model="contact.secondName"
                  type="text"
                  placeholder="请输入真实的联系人姓名"
                  @blur="touchField('contact', 'secondName')"
                />
                <button
                  v-if="contact.secondName"
                  type="button"
                  class="clear-input"
                  aria-label="清空第二联系人姓名"
                  @click="clearField('contact', 'secondName')"
                >
                  &times;
                </button>
              </div>
              <p v-if="touched.contact.secondName && fieldErrors.contact.secondName" class="field-error" role="alert">
                {{ fieldErrors.contact.secondName }}
              </p>
            </div>
            <div class="field-wrapper">
              <div class="contact-row">
                <label for="second-tel">手机号</label>
                <input
                  id="second-tel"
                  v-model="contact.secondTel"
                  type="tel"
                  maxlength="11"
                  placeholder="请输入真实有效的联系人手机号"
                  @blur="touchField('contact', 'secondTel')"
                />
                <button
                  v-if="contact.secondTel"
                  type="button"
                  class="clear-input"
                  aria-label="清空第二联系人手机号"
                  @click="clearField('contact', 'secondTel')"
                >
                  &times;
                </button>
              </div>
              <p v-if="touched.contact.secondTel && fieldErrors.contact.secondTel" class="field-error" role="alert">
                {{ fieldErrors.contact.secondTel }}
              </p>
            </div>
          </section>
        </div>
      </template>

      <template v-else>
        <button type="button" class="upload-row" @click="$router.push('/imageUpload')">
          <span class="upload-label">
            <img v-if="documentUploaded" class="upload-row-icon" src="https://static.91fd.com/tonghui_life/shangchuanxieyi1.png" alt="已上传" />
            身份证（必填）
          </span>
          <span class="upload-status">{{ documentUploaded ? "已上传" : "未上传" }}<van-icon name="arrow" /></span>
        </button>
      </template>
    </section>

    <div class="footer-actions">
      <van-button
        class="primary-button"
        type="primary"
        size="large"
        :disabled="!currentStepValid"
        @click="next"
      >
        {{ step === 2 ? "提交" : "下一步" }}
      </van-button>
      <button v-if="step" type="button" class="back-link" @click="step -= 1">
        <van-icon name="arrow-left" style="margin-top: 2px;" />
        <span>返回</span>
      </button>
    </div>

    <van-popup v-model="marriagePicker.show" position="bottom" class="picker-popup">
      <van-picker
        v-if="marriagePicker.show"
        show-toolbar
        :columns="options.marriage"
        :default-index="options.marriage.indexOf(personal.marriage)"
        item-height="40"
        visible-item-count="5"
        @confirm="confirmMarriage"
        @cancel="marriagePicker.show = false"
      />
    </van-popup>
    <van-popup v-model="educationPicker.show" position="bottom" class="picker-popup">
      <van-picker
        show-toolbar
        :columns="options.education"
        :default-index="options.education.indexOf(personal.education)"
        item-height="40"
        visible-item-count="5"
        @confirm="confirmEducation"
        @cancel="educationPicker.show = false"
      />
    </van-popup>
    <van-popup v-model="optionPicker.show" position="bottom" class="picker-popup">
      <van-picker
        v-if="optionPicker.show"
        show-toolbar
        :columns="options[optionPicker.field]"
        :default-index="options[optionPicker.field].indexOf(contact[optionPicker.field])"
        item-height="40"
        visible-item-count="5"
        @confirm="confirmOption"
        @cancel="optionPicker.show = false"
      />
    </van-popup>
    <van-popup v-model="regionPicker.show" position="bottom" class="picker-popup">
      <van-area
        title=""
        :area-list="areaList"
        :value="regionPicker.value"
        @confirm="confirmRegion"
        @cancel="regionPicker.show = false"
      />
    </van-popup>
  </main>
</template>

<script>
import { areaList } from "@vant/area-data";
import personalDefault from "../assets/images/personal-default.png";
import personalActive from "../assets/images/personal-active.png";
import personalFinish from "../assets/images/personal-finish.png";
import contactDefault from "../assets/images/contact-default.png";
import contactActive from "../assets/images/contact-active.png";
import contactFinish from "../assets/images/contact-finish.png";
import documentDefault from "../assets/images/document-default.png";
import documentActive from "../assets/images/document-active.png";
import documentFinish from "../assets/images/document-finish.png";

export default {
  name: "Infomation",
  data() {
    return {
      step: this.$route.query.step === "upload" ? 2 : 0,
      documentUploaded: sessionStorage.getItem("imageUploadComplete") === "true",
    steps: [
      { label: "个人信息", default: personalDefault, active: personalActive, finish: personalFinish },
      { label: "联系人信息", default: contactDefault, active: contactActive, finish: contactFinish },
      { label: "资料上传", default: documentDefault, active: documentActive, finish: documentFinish },
    ],
    personal: {
      residenceRegion: "浙江省杭州市余杭区",
      residenceAddress: "未来街道星云路88号3幢1204室",
      company: "星澜数字创意（测试）有限公司",
      companyRegion: "浙江省杭州市西湖区",
      companyAddress: "文新街道云栖路126号A座8层",
      marriage: "未婚",
      education: "本科",
      income: "28.6",
    },
    contact: {
      firstRelation: "母亲",
      firstName: "沈知夏",
      firstTel: "19800005678",
      secondRelation: "同事",
      secondName: "顾言川",
      secondTel: "19700004321",
    },
    touched: {
      personal: {
        residenceAddress: false,
        company: false,
        companyAddress: false,
        income: false,
      },
      contact: {
        firstName: false,
        firstTel: false,
        secondName: false,
        secondTel: false,
      },
    },
    areaList,
    regionPicker: { show: false, field: "", value: "" },
    marriagePicker: { show: false },
    educationPicker: { show: false },
    optionPicker: { show: false, field: "" },
    options: {
      education: ["硕士及以上", "本科", "大专", "高中", "初中及以下"],
      marriage: ["已婚", "未婚", "离异"],
      firstRelation: ["配偶", "父亲", "母亲", "儿子", "女儿", "朋友", "同事", "亲属"],
      secondRelation: ["配偶", "父亲", "母亲", "儿子", "女儿", "朋友", "同事", "亲属"],
    },
    };
  },
  computed: {
    fieldErrors() {
      const requiredError = (value, message) => (String(value || "").trim() ? "" : message);
      const mobileError = (value, emptyMessage, invalidMessage) => {
        const normalizedValue = String(value || "").trim();
        if (!normalizedValue) return emptyMessage;
        return /^1\d{10}$/.test(normalizedValue) ? "" : invalidMessage;
      };
      const income = String(this.personal.income || "").trim();
      let incomeError = "";
      if (!income) incomeError = "请输入年收入";
      else if (!Number.isFinite(Number(income)) || Number(income) <= 0) {
        incomeError = "请输入大于 0 的有效年收入";
      }

      return {
        personal: {
          residenceAddress: requiredError(this.personal.residenceAddress, "请输入详细居住地址"),
          company: requiredError(this.personal.company, "请输入单位名称"),
          companyAddress: requiredError(this.personal.companyAddress, "请输入单位详细地址"),
          income: incomeError,
        },
        contact: {
          firstName: requiredError(this.contact.firstName, "请输入第一联系人姓名"),
          firstTel: mobileError(
            this.contact.firstTel,
            "请输入第一联系人手机号",
            "请输入正确的第一联系人手机号"
          ),
          secondName: requiredError(this.contact.secondName, "请输入第二联系人姓名"),
          secondTel: mobileError(
            this.contact.secondTel,
            "请输入第二联系人手机号",
            "请输入正确的第二联系人手机号"
          ),
        },
      };
    },
    currentStepValid() {
      if (this.step === 0) {
        return Object.values(this.personal).every(
          (value) => value != null && String(value).trim()
        ) && Object.values(this.fieldErrors.personal).every((error) => !error);
      }
      if (this.step === 1) {
        return Object.values(this.contact).every(
          (value) => value != null && String(value).trim()
        ) && Object.values(this.fieldErrors.contact).every((error) => !error);
      }
      return this.documentUploaded;
    },
  },
  methods: {
    touchField(group, field) {
      this.touched[group][field] = true;
    },
    clearField(group, field) {
      this[group][field] = "";
      this.touchField(group, field);
    },
    stepImage(item, index) {
      if (this.step > index) return item.finish;
      if (this.step === index) return item.active;
      return item.default;
    },
    openRegionPicker(field) {
      this.regionPicker = {
        show: true,
        field,
        value: this.findRegionCode(this.personal[field]),
      };
    },
    findRegionCode(region) {
      return Object.keys(this.areaList.county_list).find((code) => {
        const province = this.areaList.province_list[`${code.slice(0, 2)}0000`] || "";
        const city = this.areaList.city_list[`${code.slice(0, 4)}00`] || "";
        return `${province}${city}${this.areaList.county_list[code]}` === region;
      }) || "";
    },
    confirmRegion(values) {
      this.personal[this.regionPicker.field] = values.map((item) => item.name).join("");
      this.regionPicker.show = false;
    },
    openOptionPicker(field) {
      this.optionPicker = { show: true, field };
    },
    confirmOption(value) {
      this.contact[this.optionPicker.field] = value;
      this.optionPicker.show = false;
    },
    confirmMarriage(value) {
      this.personal.marriage = value;
      this.marriagePicker.show = false;
    },
    confirmEducation(value) {
      this.personal.education = value;
      this.educationPicker.show = false;
    },
    next() {
      if (!this.currentStepValid) return;
      if (this.step < 2) this.step += 1;
      else this.$router.push("/submissionSuccess");
    },
  },
};
</script>

<style lang="scss" scoped>
.information {
  min-height: 100vh;
  padding-bottom: 28px;
  background: #f5f7f9;
}
.steps {
  display: flex;
  height: 74px;
  justify-content: space-around;
  padding: 10px 10px 6px;
  background: #fff;
}
.steps div {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  color: #bdbfc7;
  font-size: 16px;
}
.steps img {
  z-index: 1;
  width: 25px;
  height: 25px;
  margin-bottom: 9px;
  object-fit: contain;
}
.steps .active,
.steps .done {
  color: #d3936a;
}
.form-section {
  margin-top: 15px;
  background: #fff;
}
.form-section.contact-form {
  background: #f5f7f9;
}
.personal-row {
  position: relative;
  display: flex;
  width: 100%;
  height: 59px;
  align-items: center;
  padding: 0 16px;
  border: 0;
  background: #fff;
  color: #000;
  font: inherit;
  font-size: 16px;
  text-align: left;
}
.personal-row::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  height: 1px;
  background: #f1f2f3;
  content: "";
}
.personal-row > span:first-child,
.personal-row > label:first-child {
  width: 105px;
  flex: 0 0 105px;
}
.personal-row strong,
.personal-row input {
  min-width: 0;
  flex: 1;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #323232;
  font: inherit;
  font-weight: 400;
}
.personal-row input::placeholder,
.personal-row .placeholder {
  color: #c8c9cc;
}
.personal-row .van-icon {
  margin-left: 6px;
  color: #b8bdc5;
}
.income-row em {
  margin-left: 6px;
  color: #323232;
  font-style: normal;
}
.field-wrapper {
  background: #fff;
}
.clear-input {
  flex: 0 0 auto;
  margin-left: 8px;
  padding: 4px;
  border: 0;
  background: transparent;
  color: #b8bdc5;
  font: inherit;
  font-size: 20px;
  line-height: 1;
}
.field-error {
  min-height: 18px;
  margin: 0;
  padding: 0 16px 4px 121px;
  color: #ee0a24;
  font-size: 12px;
  line-height: 14px;
}
.contact-step {
  padding: 0 16px 20px;
  background: #f5f7f9;
}
.contact-card {
  overflow: hidden;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba(42, 56, 83, 0.04);
}
.contact-group-title {
  margin: 0;
  padding: 40px 0 10px;
  color: #a2a5b0;
  font-size: 15px;
  font-weight: 400;
}
.contact-row {
  display: flex;
  width: 100%;
  height: 59px;
  align-items: center;
  padding: 0;
  border: 0;
  background: #fff;
  color: #323232;
  font: inherit;
  font-size: 16px;
  text-align: left;
}
.contact-row > span:first-child,
.contact-row > label:first-child {
  width: 106px;
  flex: 0 0 106px;
}
.contact-row strong,
.contact-row input {
  min-width: 0;
  flex: 1;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #323232;
  font: inherit;
  font-weight: 400;
}
.contact-row input::placeholder {
  color: #c8c9cc;
}
.contact-row .van-icon {
  margin-right: 16px;
  color: #b8bdc5;
}
.contact-card .clear-input {
  margin-right: 12px;
}
.contact-card .field-error {
  padding-left: 106px;
}
.section-title {
  margin: 0;
  padding: 16px;
  font-size: 19px;
}
.upload-row {
  display: flex;
  width: 100%;
  height: 65px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border: 0;
  background: #fff;
  color: #323232;
  font: inherit;
  font-size: 16px;
  text-align: left;
}
.upload-label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.upload-row-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
.upload-status {
  display: flex;
  align-items: center;
  color: #788292;
}
.upload-status .van-icon {
  margin-left: 8px;
  color: #b8bdc5;
}
.footer-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;
}
.footer-actions .primary-button {
  width: 100%;
  height: 46px;
  margin-top: 64px;
  border-radius: 6px !important;
  background: linear-gradient(90deg, #E1A379 0%, #B36E47 100%) !important;
}
.footer-actions .primary-button.van-button--disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.back-link {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 18px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #8f9daf;
  font: inherit;
  font-size: 15px;
}
.picker-popup ::v-deep .van-picker-column__item {
  color: #999;
  font-size: 16px;
}
.picker-popup ::v-deep .van-picker-column__item--selected {
  color: #000;
}
.picker-popup ::v-deep .van-picker__frame::after {
  border-color: #f6f8f9;
}
</style>
